// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16TII","right":"Footer_right__ZICHm","buttons":"Footer_buttons__3uu6q"};